export var TermsDocumentType;
(function (TermsDocumentType) {
    TermsDocumentType["TermsAndConditions"] = "TermsAndConditions";
})(TermsDocumentType || (TermsDocumentType = {}));
